import { fg } from '@confluence/feature-gating';

// eslint-disable-next-line confluence-feature-gating/inline-usage
export const getIsNav4Enabled = () => {
	return fg('confluence_nav_4');
};
